export const actionTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    CHANGE_FUND: 'CHANGE_FUND',
}

export const initialState = {
    token: null,
    loading: true,
    role: [],
    fundID: -1,
    title: ""
}

export function reducer(state, action) {
    switch (action.type) {
        case actionTypes.LOGIN:
            return {
                ...state,
                token: action.token,
                loading: false,
                loginState: true,
                role: action.role,
                fundID: action.fundID,
                title: action.title,
                total_owner: action.total_owner
            }
        case actionTypes.CHANGE_FUND:
            return {
                ...state,
                fundID: action.fundID,
                title: action.title
            }
        case actionTypes.LOGOUT:
            return {
                ...state,
                token: null,
                loading: false,
                loginState: false,
                role: [],
                fundID: -1,
                title: "",
                total_owner: false
            }
        default:
            return {
                ...state,
                token: null,
                loading: false,
                loginState: false,
                role: [],
                fundID: -1,
                title: "",
                total_owner: false
            }
    }
}

export function setLoginStateDispatch(actionType, token = null, role = null, fundID = -1, title = "صندوق های مردم نهاد", total_owner = false) {
    return {
        type: actionType,
        token: token,
        role: role,
        fundID: fundID,
        title: title,
        total_owner: total_owner
    }
}